import React from "react";
import { useThemeContext } from "../../../../utility/AppContextProvider/ThemeContextProvider";
import { Box } from "@mui/material";

interface AppLogoProps {
  color?: string;
}

const AppLogo: React.FC<AppLogoProps> = ({ color }) => {
  const { theme } = useThemeContext();

  return (
    <Box
      sx={{
        padding: 2.5,
        display: "flex",
        flexDirection: "row",
        cursor: "pointer",
        alignItems: "center",
        justifyContent: "center",
        "& img": {
          height: { xs: 35, sm: 40 },
          width: "auto",
        },
      }}
      className="app-logo"
    >
      <img src="/assets/icon/logo.png" alt="Logo" />
    </Box>
  );
};

export default AppLogo;